import { message } from "antd"
import Title from "antd/es/typography/Title"
import React, { useCallback, useEffect, useState } from "react"
import { t } from "~/languages/i18n"
import { SEOAttributes, SEOData } from "~/types/types"
import { fetchSeoSetting, updateSeoSetting } from "../services/seoSetting"
import SEOForm from "./FormSeoSetting"

const SeoListing: React.FC = () => {
  const [dataItem, setDataItem] = useState<SEOData | null>(null)

  const fetchSEOSettingData = useCallback(async () => {
    try {
      const response = await fetchSeoSetting()
      setDataItem(response.data)
    } catch (error) {
      message.error(t("Error fetching SEO settings:"))
    }
  }, [])

  const handleFormSubmit = async (values: Partial<SEOAttributes>) => {
    if (!dataItem) return

    const updatedData: Partial<SEOAttributes> = {}

    if (values.metaTitle?.trim()) updatedData.metaTitle = values.metaTitle
    if (values.metaDescription?.trim()) updatedData.metaDescription = values.metaDescription
    if (values.metaKeywords?.trim()) updatedData.metaKeywords = values.metaKeywords

    if (values.MetaImage) updatedData.MetaImage = values.MetaImage

    try {
      await updateSeoSetting(updatedData)
      await fetchSEOSettingData()

      message.success(t("SEO settings updated successfully."))
    } catch (error) {
      message.error(t("Error submitting form:"))
      message.error(t("Failed to update SEO settings."))
    }
  }

  useEffect(() => {
    fetchSEOSettingData()
  }, [fetchSEOSettingData])

  return (
    <div className="p-4">
      <div className="flex space-x-4 items-center">
        <Title level={2} className="m-0">
          {t("General Setting")}
        </Title>
      </div>
      {dataItem && (
        <SEOForm
          onSubmit={handleFormSubmit}
          initialValues={{
            metaTitle: dataItem.attributes.metaTitle || "",
            metaDescription: dataItem.attributes.metaDescription || "",
            metaKeywords: dataItem.attributes.metaKeywords || "",
            MetaImage: dataItem.attributes.MetaImage?.data,
          }}
        />
      )}
    </div>
  )
}

export default SeoListing
